/** `/c/$companyId/purchases/bills/new?supplier&copyOf` — a new bill, created on its first save. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SupplierDocPage } from "../bills/page/SupplierDocPage";

const search = z.object({
  supplier: z.string().uuid().optional().catch(undefined),
  /** A reversed bill entered again: its contents start the new one. */
  copyOf: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/bills/new")({
  validateSearch: (raw) => search.parse(raw),
  component: NewBillRoute,
});

function NewBillRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { supplier, copyOf } = Route.useSearch();
  return <SupplierDocPage companyId={companyId} kind="bills" supplier={supplier} copyOf={copyOf} />;
}
